import React from 'react';
import { List, ListItem } from '@hub/list';
import { MenuLink } from '../../../../packages/hub/navigation/src/menu-link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MegaMenuItem = _ref => {
  let {
    megaMenuItem,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsxs(List, {
    "data-id": "mega-menu_mega-menu-item_MegaMenuItem_List",
    children: [/*#__PURE__*/_jsx(ListItem, {
      "data-id": "mega-menu_mega-menu-item_MegaMenuItem_List_ListItem",
      children: /*#__PURE__*/_jsx(MenuLink, {
        tone: "strong",
        onClick: event => onClick === null || onClick === void 0 ? void 0 : onClick(event, [megaMenuItem]),
        href: megaMenuItem.url,
        "data-id": "mega-menu_mega-menu-item_MegaMenuItem_ListItem_MenuLink",
        children: megaMenuItem.label
      })
    }), megaMenuItem.items && megaMenuItem.items.map((subItem, i) => /*#__PURE__*/_jsx(ListItem, {
      "data-id": "mega-menu_mega-menu-item_MegaMenuItem_ListItem",
      children: /*#__PURE__*/_jsx(MenuLink, {
        href: subItem.url,
        onClick: event => onClick === null || onClick === void 0 ? void 0 : onClick(event, [megaMenuItem, subItem]),
        "data-id": "mega-menu_mega-menu-item_MegaMenuItem_ListItem_MenuLink",
        children: subItem.label
      })
    }, i))]
  });
};